// Module
var code = " <p class=\"item-amount\"> <span ng-bind=\"$ctrl.purchaseItem.units_remaining || '' \"></span> </p> ";
// Exports
export default code;